import { render, staticRenderFns } from "./DestinationsView.vue?vue&type=template&id=341d7bb2&scoped=true"
import script from "./DestinationsView.vue?vue&type=script&lang=js"
export * from "./DestinationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d7bb2",
  null
  
)

export default component.exports